import React from "react";
import dateFormat from "dateformat";
import { format } from "date-fns";
import styles from "./DateNavigation.module.scss";
import arrowLeftIcon from "@/assets/icons/arrowCalendarLeft.svg";
import arrowRightIcon from "@/assets/icons/arrowCalendarRight.svg";

interface DateNavigationProps {
  date: string;
  onDateChange: (date: string) => void;
}

const getPrevMonth = (date: string): Date => {
  if (!date) {
    return new Date();
  }
  const currentDay = new Date(date);
  if (isNaN(currentDay.getTime())) {
    return new Date();
  }
  currentDay.setMonth(currentDay.getMonth() - 1);
  return currentDay;
};

const getNextMonth = (date: string): Date => {
  if (!date) {
    return new Date();
  }
  const currentDay = new Date(date);
  if (isNaN(currentDay.getTime())) {
    return new Date();
  }
  currentDay.setMonth(currentDay.getMonth() + 1);
  return currentDay;
};

const formatCurrentDate = (date: string): { monthName: string; yearName: string } => {
  if (!date) {
    const today = new Date();
    const monthNames = [
      "Январь",
      "Февраль",
      "Март",
      "Апрель",
      "Май",
      "Июнь",
      "Июль",
      "Август",
      "Сентябрь",
      "Октябрь",
      "Ноябрь",
      "Декабрь",
    ];
    return {
      monthName: monthNames[today.getMonth()],
      yearName: today.getFullYear().toString(),
    };
  }
  
  const currentDate = new Date(date);
  if (isNaN(currentDate.getTime())) {
    const today = new Date();
    const monthNames = [
      "Январь",
      "Февраль",
      "Март",
      "Апрель",
      "Май",
      "Июнь",
      "Июль",
      "Август",
      "Сентябрь",
      "Октябрь",
      "Ноябрь",
      "Декабрь",
    ];
    return {
      monthName: monthNames[today.getMonth()],
      yearName: today.getFullYear().toString(),
    };
  }
  
  const monthNames = [
    "Январь",
    "Февраль",
    "Март",
    "Апрель",
    "Май",
    "Июнь",
    "Июль",
    "Август",
    "Сентябрь",
    "Октябрь",
    "Ноябрь",
    "Декабрь",
  ];
  return {
    monthName: monthNames[currentDate.getMonth()],
    yearName: currentDate.getFullYear().toString(),
  };
};

const isPrevMonthDisabled = (date: string): boolean => {
  if (!date) {
    return true;
  }
  const currentDate = new Date(date);
  const now = new Date();
  return currentDate.getFullYear() === now.getFullYear() && currentDate.getMonth() === now.getMonth();
};

export const DateNavigation: React.FC<DateNavigationProps> = ({ date, onDateChange }) => {
  // Проверяем, что date валидный
  const validDate = date && !isNaN(new Date(date).getTime()) ? date : format(new Date(), "yyyy-MM-dd");
  
  console.log("[DateNavigation] Props:", { date, validDate });
  
  const currentDate = formatCurrentDate(validDate);
  const disablePrevButton = isPrevMonthDisabled(validDate);

  const handlePrevMonth = () => {
    const prevDate = format(getPrevMonth(validDate), "yyyy-MM-dd");
    console.log("[DateNavigation] handlePrevMonth:", prevDate);
    onDateChange(prevDate);
  };

  const handleNextMonth = () => {
    const nextDate = format(getNextMonth(validDate), "yyyy-MM-dd");
    console.log("[DateNavigation] handleNextMonth:", nextDate);
    onDateChange(nextDate);
  };

  return (
    <div className={styles.navigate}>
      <button
        className={styles.navigate_button}
        disabled={disablePrevButton}
        onClick={handlePrevMonth}
      >
        <img src={arrowLeftIcon} alt="prev day" />
      </button>
      <div className={styles.navigate_currentDay}>
        <span className={styles.navigate_currentDay_name}>
          {currentDate.monthName} {currentDate.yearName}
        </span>
      </div>
      <button className={styles.navigate_button} onClick={handleNextMonth}>
        <img src={arrowRightIcon} alt="next day" />
      </button>
    </div>
  );
};
